module.exports = __webpack_public_path__ + "img/3-kaiho.1391aada.jpg";